import { defineAttrs as e } from "../../utils/typed-attrs.js";
var t = {
	content: "",
	attrs: e({
		type: { default: "html" },
		content: { default: "" }
	}),
	group: "block",
	parseDOM: [{ tag: ".embercom-prosemirror-composer-html-block .intercom-interblocks-html-block" }],
	toDOM() {
		return ["div", { class: "embercom-prosemirror-composer-mention" }];
	}
};
//#endregion
export { t as htmlSpec };
